var exports = {
  "_": "x234b8571--9c7213--nav_container",
  "Y": "x234b8571--9c7213--reviews",
};

module.exports = exports;
